@let fieldSettings = fieldsSettings$ | async;

@if (fieldSettings) {
  <form [formGroup]="form">
    <ion-list lines="full" [inset]="true" class="no-last-line">
      <ion-list-header> Transaction Information</ion-list-header>

      <ion-item-divider> Property </ion-item-divider>
      <ion-item>
        <ion-input
          [redRequired]="fieldSettings['transactionInformationPropertyAddress'].required === true"
          formControlName="transactionInformationPropertyAddress"
          labelPlacement="stacked"
          placeholder="eg. 123 Main Street"
          inputmode="text"
          redErrorMessage
          type="text"
        >
          <div slot="label" class="tw:whitespace-normal">
            Property Address
            @if (fieldSettings['transactionInformationPropertyAddress'].required) {
              <ion-text color="danger">*</ion-text>
            }
          </div>
        </ion-input>
      </ion-item>

      @if (fieldSettings['transactionInformationPropertyState'].visible) {
        @let transactionInformationPropertyStates = (transactionInformationPropertyStates$ | async) ?? [];
        <red-searchable-select
          redErrorMessage
          [redRequired]="fieldSettings['transactionInformationPropertyState'].required === true"
          formControlName="transactionInformationPropertyState"
          [options]="transactionInformationPropertyStates"
          placeholder="Select state"
          searchPlaceholder="Search states..."
        >
          <span searchable-select-label class="tw:whitespace-normal">
            Property State
            @if (fieldSettings['transactionInformationPropertyState'].required) {
              <ion-text color="danger">*</ion-text>
            }
          </span>
        </red-searchable-select>
      }

      @if (fieldSettings['transactionInformationPropertyCounty'].visible) {
        @let transactionInformationPropertyCounties = (transactionInformationPropertyCounties$ | async) ?? [];
        <red-searchable-select
          redErrorMessage
          [redRequired]="fieldSettings['transactionInformationPropertyCounty'].required === true"
          formControlName="transactionInformationPropertyCounty"
          [options]="transactionInformationPropertyCounties"
          placeholder="Select county"
          searchPlaceholder="Search counties..."
        >
          <span searchable-select-label class="tw:whitespace-normal">
            Property County
            @if (fieldSettings['transactionInformationPropertyCounty'].required) {
              <ion-text color="danger">*</ion-text>
            }
          </span>
        </red-searchable-select>
      }

      @if (fieldSettings['transactionInformationPropertyCity'].visible) {
        @let transactionInformationPropertyCities = (transactionInformationPropertyCities$ | async) ?? [];
        <red-searchable-select
          redErrorMessage
          [redRequired]="fieldSettings['transactionInformationPropertyCity'].required === true"
          formControlName="transactionInformationPropertyCity"
          [options]="transactionInformationPropertyCities"
          placeholder="Select city"
          searchPlaceholder="Search cities..."
        >
          <span searchable-select-label class="tw:whitespace-normal">
            Property City
            @if (fieldSettings['transactionInformationPropertyCity'].required) {
              <ion-text color="danger">*</ion-text>
            }
          </span>
        </red-searchable-select>
      }

      @if (fieldSettings['transactionInformationPropertyZip'].visible) {
        @let transactionInformationPropertyZips = (transactionInformationPropertyZips$ | async) ?? [];

        <red-searchable-select
          redErrorMessage
          [redRequired]="fieldSettings['transactionInformationPropertyZip'].required === true"
          formControlName="transactionInformationPropertyZip"
          [options]="transactionInformationPropertyZips"
          [allowCustomValue]="true"
          placeholder="Select zip"
          searchPlaceholder="Search zips..."
        >
          <span searchable-select-label class="tw:whitespace-normal">
            Property Zip
            @if (fieldSettings['transactionInformationPropertyZip'].required) {
              <ion-text color="danger">*</ion-text>
            }
          </span>
        </red-searchable-select>
      }

      <ion-item-divider> Escrow </ion-item-divider>
      @if (fieldSettings['transactionInformationEscrowState'].visible) {
        @let transactionInformationEscrowStates = (transactionInformationEscrowStates$ | async) ?? [];
        <red-searchable-select
          redErrorMessage
          [redRequired]="fieldSettings['transactionInformationEscrowState'].required === true"
          formControlName="transactionInformationEscrowState"
          [options]="transactionInformationEscrowStates"
          placeholder="Select state"
          searchPlaceholder="Search states..."
        >
          <span searchable-select-label class="tw:whitespace-normal">
            Escrow State
            @if (fieldSettings['transactionInformationEscrowState'].required) {
              <ion-text color="danger">*</ion-text>
            }
          </span>
        </red-searchable-select>
      }

      @if (fieldSettings['transactionInformationEscrowCounty'].visible) {
        @let transactionInformationEscrowCounties = (transactionInformationEscrowCounties$ | async) ?? [];
        <red-searchable-select
          redErrorMessage
          [redRequired]="fieldSettings['transactionInformationEscrowCounty'].required === true"
          formControlName="transactionInformationEscrowCounty"
          [options]="transactionInformationEscrowCounties"
          placeholder="Select county"
          searchPlaceholder="Search counties..."
        >
          <span searchable-select-label class="tw:whitespace-normal">
            Escrow County
            @if (fieldSettings['transactionInformationEscrowCounty'].required) {
              <ion-text color="danger">*</ion-text>
            }
          </span>
        </red-searchable-select>
      }

      @if (fieldSettings['transactionInformationEscrowCity'].visible) {
        @let transactionInformationEscrowCities = (transactionInformationEscrowCities$ | async) ?? [];
        <red-searchable-select
          redErrorMessage
          [redRequired]="fieldSettings['transactionInformationEscrowCity'].required === true"
          formControlName="transactionInformationEscrowCity"
          [options]="transactionInformationEscrowCities"
          placeholder="Select city"
          searchPlaceholder="Search cities..."
        >
          <span searchable-select-label class="tw:whitespace-normal">
            Escrow County
            @if (fieldSettings['transactionInformationEscrowCity'].required) {
              <ion-text color="danger">*</ion-text>
            }
          </span>
        </red-searchable-select>
      }

      @if (fieldSettings['transactionInformationEscrowBranch'].visible) {
        @let transactionInformationEscrowBranches = (transactionInformationEscrowBranches$ | async) ?? [];
        <red-searchable-select
          redErrorMessage
          [redRequired]="fieldSettings['transactionInformationEscrowBranch'].required === true"
          formControlName="transactionInformationEscrowBranch"
          [options]="transactionInformationEscrowBranches"
          placeholder="Select branch"
          searchPlaceholder="Search branches..."
        >
          <span searchable-select-label class="tw:whitespace-normal">
            Escrow Branch
            @if (fieldSettings['transactionInformationEscrowBranch'].required) {
              <ion-text color="danger">*</ion-text>
            }
          </span>
        </red-searchable-select>
      }

      @if (fieldSettings['transactionInformationEscrowFeeSplit'].visible) {
        <ion-item lines="full">
          <ion-select
            redErrorMessage
            formControlName="transactionInformationEscrowFeeSplit"
            placeholder="Please select"
            labelPlacement="stacked"
            [interfaceOptions]="{ header: 'Escrow Fee paid by:' }"
          >
            <div slot="label" class="tw:whitespace-normal">Escrow Fee paid by:</div>
            <ion-select-option [value]="defaultSplitOptions.Seller">Seller</ion-select-option>
            <ion-select-option [value]="defaultSplitOptions.Buyer">Buyer</ion-select-option>
            <ion-select-option [value]="defaultSplitOptions.Split">Split 50/50</ion-select-option>
          </ion-select>
        </ion-item>
      }

      <ion-item-divider> Slide right all that apply: </ion-item-divider>

      @if (fieldSettings['transactionInformationShortSale'].visible) {
        <ion-item>
          <ion-toggle formControlName="transactionInformationShortSale">
            <span class="tw:text-xs tw:whitespace-normal">Transaction involves a Short Sale</span>
          </ion-toggle>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationReo'].visible) {
        <ion-item>
          <ion-toggle formControlName="transactionInformationReo">
            <span class="tw:text-xs tw:whitespace-normal">Subject property owned by a lender (REO)</span>
          </ion-toggle>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationNewLoan'].visible) {
        <ion-item>
          <ion-toggle formControlName="transactionInformationNewLoan">
            <span class="tw:text-xs tw:whitespace-normal">Buyer is obtaining a new loan</span>
          </ion-toggle>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationFirpta'].visible) {
        <ion-item>
          <ion-toggle formControlName="transactionInformationFirpta">
            <span class="tw:text-xs tw:whitespace-normal"
              >Seller is a U.S. Citizen (pursuant to FIRPTA requirements)</span
            >
          </ion-toggle>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationPersonalResidence'].visible) {
        <ion-item>
          <ion-toggle formControlName="transactionInformationPersonalResidence">
            <span class="tw:text-xs tw:whitespace-normal"
              >Buyer is acquiring the property as their personal residence</span
            >
          </ion-toggle>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationFtb'].visible) {
        <ion-item>
          <ion-toggle formControlName="transactionInformationFtb">
            <span class="tw:text-xs tw:whitespace-normal">Property is the principal residence of the seller</span>
          </ion-toggle>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationPropertyIncorporatedArea'].visible) {
        <ion-item>
          <ion-toggle formControlName="transactionInformationPropertyIncorporatedArea">
            <span class="tw:text-xs tw:whitespace-normal">Within the City Limits</span>
          </ion-toggle>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationOwnersExemption'].visible) {
        <ion-item>
          <ion-toggle formControlName="transactionInformationOwnersExemption">
            <span class="tw:text-xs tw:whitespace-normal"
              >Buyer is eligible for a county homeowner's exemption on property tax</span
            >
          </ion-toggle>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationHarpta'].visible) {
        <ion-item>
          <ion-toggle formControlName="transactionInformationHarpta">
            <span class="tw:text-xs tw:whitespace-normal">Seller is a resident of Hawaii</span>
          </ion-toggle>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationSurveyAmendmentSplit'].visible) {
        <ion-item>
          <ion-toggle formControlName="transactionInformationSurveyAmendmentSplit">
            <span class="tw:text-xs tw:whitespace-normal">Seller is paying for the Survey Amendment</span>
          </ion-toggle>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationSubEscrow'].visible) {
        <ion-item-divider>
          <span class="tw:whitespace-normal">Services to be performed by Old Republic Title:</span>
        </ion-item-divider>

        <ion-radio-group formControlName="transactionInformationSubEscrow">
          <ion-item>
            <ion-radio class="tw:text-xs" [value]="false">Primary Escrow Services</ion-radio>
          </ion-item>
          <ion-item>
            <ion-radio class="tw:text-xs" [value]="true">Secondary Escrow Services (Sub-Escrow)</ion-radio>
          </ion-item>
        </ion-radio-group>
      }

      @if (fieldSettings['transactionInformationOwnersPolicySplit'].visible) {
        <ion-item>
          <ion-select
            redErrorMessage
            formControlName="transactionInformationOwnersPolicySplit"
            placeholder="Please select"
            labelPlacement="stacked"
            [interfaceOptions]="{ header: 'Owner\'s Title Insurance paid by:' }"
          >
            <div slot="label" class="tw:whitespace-normal">Owner's Title Insurance paid by:</div>
            <ion-select-option [value]="defaultSplitOptions.Seller">Seller</ion-select-option>
            <ion-select-option [value]="defaultSplitOptions.Buyer">Buyer</ion-select-option>
            <ion-select-option [value]="defaultSplitOptions.Split">Split 50/50</ion-select-option>
          </ion-select>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationSalesPrice'].visible) {
        <ion-item>
          <ion-input
            redErrorMessage
            [redRequired]="fieldSettings['transactionInformationSalesPrice'].required === true"
            formControlName="transactionInformationSalesPrice"
            labelPlacement="stacked"
            placeholder="$"
            inputmode="decimal"
            type="text"
            [maskito]="amountMask"
            [maskitoElement]="maskPredicate"
          >
            <div slot="label" class="tw:whitespace-normal">
              Sales Price
              @if (fieldSettings['transactionInformationSalesPrice'].required) {
                <ion-text color="danger">*</ion-text>
              }
            </div>
          </ion-input>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationClosingDate'].visible) {
        <ion-item>
          <ion-input
            redErrorMessage
            [redRequired]="fieldSettings['transactionInformationClosingDate'].required === true"
            formControlName="transactionInformationClosingDate"
            labelPlacement="stacked"
            placeholder="mm/dd/yyyy"
            inputmode="text"
            type="text"
            tabindex="0"
            (keydown.enter)="onDatePickerInputClick($event)"
            (keydown.space)="onDatePickerInputClick($event)"
            (click)="onDatePickerInputClick($event)"
            [readonly]="true"
          >
            <div slot="label" class="tw:whitespace-normal">
              Closing Date
              @if (fieldSettings['transactionInformationClosingDate'].required) {
                <ion-text color="danger">*</ion-text>
              }
            </div>
          </ion-input>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationNaturalHazardDisclosure'].visible) {
        <ion-item>
          <ion-input
            redErrorMessage
            [redRequired]="fieldSettings['transactionInformationNaturalHazardDisclosure'].required === true"
            formControlName="transactionInformationNaturalHazardDisclosure"
            labelPlacement="stacked"
            placeholder="$"
            inputmode="decimal"
            type="text"
            [maskito]="amountMask"
            [maskitoElement]="maskPredicate"
          >
            <div slot="label" class="tw:whitespace-normal">
              Natural Hazard Disclosure
              @if (fieldSettings['transactionInformationNaturalHazardDisclosure'].required) {
                <ion-text color="danger">*</ion-text>
              }
            </div>
          </ion-input>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationLoanPrimaryAmount'].visible) {
        <ion-item>
          <ion-input
            redErrorMessage
            [redRequired]="fieldSettings['transactionInformationLoanPrimaryAmount'].required === true"
            formControlName="transactionInformationLoanPrimaryAmount"
            labelPlacement="stacked"
            placeholder="$"
            inputmode="decimal"
            type="text"
            [maskito]="amountMask"
            [maskitoElement]="maskPredicate"
          >
            <div slot="label" class="tw:whitespace-normal">
              Loan Amount
              @if (fieldSettings['transactionInformationLoanPrimaryAmount'].required) {
                <ion-text color="danger">*</ion-text>
              }
            </div>
          </ion-input>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationLoanPrimaryOriginationFees'].visible) {
        <ion-item>
          <ion-input
            redErrorMessage
            formControlName="transactionInformationLoanPrimaryOriginationFees"
            labelPlacement="stacked"
            placeholder="$ / %"
            inputmode="decimal"
            type="text"
            [maskito]="rateAmountMask"
            [maskitoElement]="maskPredicate"
          >
            <div slot="label" class="tw:whitespace-normal">Loan Origination Fees</div>
          </ion-input>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationLoanPrimaryInterestRate'].visible) {
        <ion-item>
          <ion-input
            redErrorMessage
            formControlName="transactionInformationLoanPrimaryInterestRate"
            labelPlacement="stacked"
            placeholder="%"
            inputmode="decimal"
            type="text"
            [maskito]="rateMask"
            [maskitoElement]="maskPredicate"
          >
            <div slot="label" class="tw:whitespace-normal">Interest % On New Loan</div>
          </ion-input>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationBuyerCreditAmount'].visible) {
        <ion-item>
          <ion-input
            redErrorMessage
            formControlName="transactionInformationBuyerCreditAmount"
            labelPlacement="stacked"
            placeholder="$"
            inputmode="decimal"
            type="text"
            [maskito]="amountMask"
            [maskitoElement]="maskPredicate"
          >
            <div slot="label" class="tw:whitespace-normal">{{ buyerCreditAmountLabel$ | async }}</div>
          </ion-input>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationWarrantyPremiumAmount'].visible) {
        <ion-item>
          <ion-input
            redErrorMessage
            formControlName="transactionInformationWarrantyPremiumAmount"
            labelPlacement="stacked"
            placeholder="$"
            inputmode="decimal"
            type="text"
            [maskito]="amountMask"
            [maskitoElement]="maskPredicate"
          >
            <div slot="label" class="tw:whitespace-normal">Home Warranty Premium</div>
          </ion-input>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationHazardInsuranceAmount'].visible) {
        <ion-item>
          <ion-input
            redErrorMessage
            formControlName="transactionInformationHazardInsuranceAmount"
            labelPlacement="stacked"
            placeholder="$"
            inputmode="decimal"
            type="text"
            [maskito]="amountMask"
            [maskitoElement]="maskPredicate"
          >
            <div slot="label" class="tw:whitespace-normal">Hazard Insurance Premium</div>
          </ion-input>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationMortgagePayoffCount'].visible) {
        <ion-item>
          <ion-input
            redErrorMessage
            formControlName="transactionInformationMortgagePayoffCount"
            labelPlacement="stacked"
            placeholder=""
            inputmode="numeric"
            type="number"
          >
            <div slot="label" class="tw:whitespace-normal">Number of Mortgage Payoffs</div>
          </ion-input>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationWaterBill'].visible) {
        <ion-item>
          <ion-input
            redErrorMessage
            formControlName="transactionInformationWaterBill"
            labelPlacement="stacked"
            placeholder="$"
            inputmode="decimal"
            type="text"
            [maskito]="amountMask"
            [maskitoElement]="maskPredicate"
          >
            <div slot="label" class="tw:whitespace-normal">Final Water Bill</div>
          </ion-input>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationSewerBill'].visible) {
        <ion-item>
          <ion-input
            redErrorMessage
            formControlName="transactionInformationSewerBill"
            labelPlacement="stacked"
            placeholder="$"
            inputmode="decimal"
            type="text"
            [maskito]="amountMask"
            [maskitoElement]="maskPredicate"
          >
            <div slot="label" class="tw:whitespace-normal">Final Sewer Bill</div>
          </ion-input>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationBrokerageFee'].visible) {
        <ion-item>
          <ion-input
            redErrorMessage
            formControlName="transactionInformationBrokerageFee"
            labelPlacement="stacked"
            placeholder="$"
            inputmode="decimal"
            type="text"
            [maskito]="amountMask"
            [maskitoElement]="maskPredicate"
          >
            <div slot="label" class="tw:whitespace-normal">Brokerage Fee</div>
          </ion-input>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationNotaryFee'].visible) {
        <ion-item>
          <ion-input
            redErrorMessage
            formControlName="transactionInformationNotaryFee"
            labelPlacement="stacked"
            placeholder="$"
            inputmode="decimal"
            type="text"
            [maskito]="amountMask"
            [maskitoElement]="maskPredicate"
          >
            <div slot="label" class="tw:whitespace-normal">Notary / Signing Fee</div>
          </ion-input>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationCountyTransferTaxSplit'].visible) {
        <ion-item>
          <ion-select
            redErrorMessage
            formControlName="transactionInformationCountyTransferTaxSplit"
            placeholder="Please select"
            labelPlacement="stacked"
            [interfaceOptions]="{ header: 'County Transfer Tax paid by:' }"
          >
            <div slot="label" class="tw:whitespace-normal">County Transfer Tax paid by:</div>
            <ion-select-option [value]="defaultSplitOptions.Seller">Seller</ion-select-option>
            <ion-select-option [value]="defaultSplitOptions.Buyer">Buyer</ion-select-option>
            <ion-select-option [value]="defaultSplitOptions.Split">Split 50/50</ion-select-option>
          </ion-select>
        </ion-item>
      }

      @if (fieldSettings['transactionInformationCityTransferTaxSplit'].visible) {
        <ion-item>
          <ion-select
            redErrorMessage
            formControlName="transactionInformationCityTransferTaxSplit"
            placeholder="Please select"
            labelPlacement="stacked"
            [interfaceOptions]="{ header: 'City Transfer Tax paid by:' }"
          >
            <div slot="label" class="tw:whitespace-normal">City Transfer Tax paid by:</div>
            <ion-select-option [value]="defaultSplitOptions.Seller">Seller</ion-select-option>
            <ion-select-option [value]="defaultSplitOptions.Buyer">Buyer</ion-select-option>
            <ion-select-option [value]="defaultSplitOptions.Split">Split 50/50</ion-select-option>
          </ion-select>
        </ion-item>
      }
    </ion-list>
  </form>
}
